import React, { ReactNode, useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';

interface LayoutProps {
  children: ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isDesktopSidebarOpen, setIsDesktopSidebarOpen] = useState(true);

  return (
    <div className="h-screen w-full bg-gray-100 flex overflow-hidden">
      {/* Sidebar - Static on Desktop, Modal on Mobile */}
      <div className="flex-none z-30">
        <Sidebar
          isOpen={isSidebarOpen}
          isDesktopOpen={isDesktopSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />
      </div>

      {/* Main Content Column */}
      <div className="flex-1 flex flex-col min-w-0 bg-gray-100 h-full relative">

        {/* Mobile Header / Hamburger */}
        <div className="lg:hidden bg-white h-16 shadow-sm p-4 flex items-center justify-between flex-none z-20">
          <button
            onClick={() => setIsSidebarOpen(true)}
            className="p-2 rounded-md hover:bg-gray-100 text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <span className="font-bold text-gray-700">María Regna ERP</span>
          <div className="w-10"></div>
        </div>

        {/* Desktop Header - Sticky/Relative in Flex Flow */}
        <div className="hidden lg:block bg-white shadow-sm h-16 flex-none z-20">
          <Header toggleSidebar={() => setIsDesktopSidebarOpen(!isDesktopSidebarOpen)} />
        </div>

        {/* Scrollable Content Area */}
        <main className="flex-1 overflow-y-auto p-4 lg:p-8 bg-gray-100 relative">
          <div className="max-w-screen-2xl w-full h-full">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};
